import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import OurHosting from "./OurHosting/OurHosting"
import  HostingServices from "./HostingServices/HostingServices"
import StandOut from "./StandOut/Standout"
import Recent from  "./Recent/Recent"
import BrandingSolutions from "./Branding-Solutions/Branding-Solutions"
import WhyBranding from "./WhyBranding/WhyBranding"
import Services from "./Serivces/Services"
import  Projects from "./Projects/Projects"
import Process from "./Process/Process"

function Branding() {
  return (
    <React.Fragment>
      <Header />
      <OurHosting />
      <HostingServices />
      <StandOut />
      <Recent />
      <BrandingSolutions />
      <WhyBranding />
      <Services />
      <Process />
      <Projects />
      <Footer />
    </React.Fragment>
  )
}

export default Branding